import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "las la-reply" }, null, -1)
const _hoisted_6 = { class: "card-body p-9" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "col-2 d-flex align-items-center fs-6 fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Tên kế hoạch:")
], -1)
const _hoisted_9 = { class: "col-3 d-flex align-items-center" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = { class: "row" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "col-2 d-flex align-items-center fs-6 fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Tháng:")
], -1)
const _hoisted_14 = { class: "col-3 d-flex align-items-center" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = { class: "row" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "col-2 d-flex align-items-center fs-6 fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Ghi chú:")
], -1)
const _hoisted_19 = { class: "col-8 d-flex align-items-center" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_22 = { class: "row d-flex align-items-center" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { class: "col-2 d-flex align-items-center fs-6 fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Tên toa xe:")
], -1)
const _hoisted_24 = { class: "col-4 d-flex align-items-center" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { class: "col-2 d-flex align-items-center fs-6 fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Toa xe đã chọn:")
], -1)
const _hoisted_26 = { class: "col-lg-3" }
const _hoisted_27 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_30 = {
  key: 0,
  class: "row"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_33 = { class: "d-flex mt-5 justify-content-end row" }
const _hoisted_34 = ["data-kt-indicator"]
const _hoisted_35 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_36 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_37 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_38 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_41 = { class: "row" }
const _hoisted_42 = {
  key: 1,
  class: "card-title m-0"
}
const _hoisted_43 = /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Chưa có vật tư nào được chọn", -1)
const _hoisted_44 = [
  _hoisted_43
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProductSelectionDialog = _resolveComponent("ProductSelectionDialog")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_SupplySelection = _resolveComponent("SupplySelection")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_SelectedSupplies = _resolveComponent("SelectedSupplies")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ProductSelectionDialog, {
      allCategoryProducts: _ctx.allCategories,
      selectingProducts: _ctx.productSelectingList,
      progress: _ctx.productSelectionProgress,
      onOnSelectedCategory: _ctx.categorySelectedHandler,
      onBackToCategorySelecting: _ctx.backToCategorySelecting,
      onOnSelectedProduct: _ctx.productSelectedHandler
    }, null, 8, ["allCategoryProducts", "selectingProducts", "progress", "onOnSelectedCategory", "onBackToCategorySelecting", "onOnSelectedProduct"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.isCreated ? "Tạo mới" : "Chỉnh sửa") + " kế hoạch ", 1)
        ]),
        _createVNode(_component_router_link, {
          to: "/quan-ly/ke-hoach-sua-chua",
          class: "btn btn-primary align-self-center"
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_el_form, {
          ref: "formRef",
          class: "form",
          onSubmit: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.onSubmit()), ["prevent"])),
          model: _ctx.repairingPlanForm,
          rules: _ctx.rules
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_el_form_item, {
                  prop: "name",
                  class: "mb-0"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.repairingPlanForm.name,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.repairingPlanForm.name) = $event)),
                      placeholder: "mời nhập tên kế hoạch",
                      name: "name"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _hoisted_10,
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.repairingPlanForm.month,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.repairingPlanForm.month) = $event)),
                  placeholder: "Chọn tháng",
                  name: "month"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(12, (index) => {
                      return _createVNode(_component_el_option, {
                        key: index,
                        label: 'Tháng ' + index,
                        value: index
                      }, null, 8, ["label", "value"])
                    }), 64))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _hoisted_15,
            _hoisted_16,
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _createElementVNode("div", _hoisted_19, [
                _createVNode(_component_el_form_item, {
                  prop: "note",
                  class: "mb-0 w-100"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.repairingPlanForm.note,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.repairingPlanForm.note) = $event)),
                      placeholder: "mời nhập mô tả",
                      name: "note"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _hoisted_20,
            _hoisted_21,
            _createElementVNode("div", _hoisted_22, [
              _hoisted_23,
              _createElementVNode("div", _hoisted_24, [
                _createVNode(_component_el_button, {
                  onClick: _ctx.openProductSelectionDialog,
                  disabled: !_ctx.isCreated
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.productSelectionProgress === _ctx.PRODUCT_SELECTING_PROGRESS.DONE ||
                _ctx.selectedProductName
                  ? "Thay đổi"
                  : "Chọn") + " toa xe", 1)
                  ]),
                  _: 1
                }, 8, ["onClick", "disabled"])
              ]),
              (
              _ctx.productSelectionProgress === _ctx.PRODUCT_SELECTING_PROGRESS.DONE ||
              _ctx.selectedProductName
            )
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _hoisted_25,
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.selectedProductName), 1)
                    ])
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _hoisted_28,
            _hoisted_29,
            (_ctx.isCreated)
              ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                  _createVNode(_component_SupplySelection, { onOnSelectedSupply: _ctx.addVatTuToKeHoach }, null, 8, ["onOnSelectedSupply"])
                ]))
              : _createCommentVNode("", true),
            _hoisted_31,
            _hoisted_32,
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("button", {
                onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.resetForm && _ctx.resetForm(...args)), ["prevent"])),
                class: "btn btn-white me-3 col-2"
              }, " Xóa thông tin đã nhập "),
              _createElementVNode("button", {
                "data-kt-indicator": _ctx.loading ? 'on' : null,
                class: "btn btn-lg btn-primary col-2 me-4",
                type: "submit"
              }, [
                (!_ctx.loading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_35, [
                      _createTextVNode(_toDisplayString(_ctx.isCreated ? "Tạo mới" : "Chỉnh sửa") + " kế hoạch ", 1),
                      _createElementVNode("span", _hoisted_36, [
                        _createVNode(_component_inline_svg, { src: "icons/duotune/arrows/arr064.svg" })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.loading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_37, [
                      _createTextVNode(" Xin đợi ... "),
                      _hoisted_38
                    ]))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_34)
            ]),
            _hoisted_39,
            _hoisted_40,
            _createElementVNode("div", _hoisted_41, [
              (_ctx.selectedSupplies.length > 0)
                ? (_openBlock(), _createBlock(_component_SelectedSupplies, {
                    key: 0,
                    isCreated: _ctx.isCreated,
                    items: _ctx.selectedSupplies,
                    onOnDeleteClicked: _ctx.removeFromSelectedSupplies
                  }, null, 8, ["isCreated", "items", "onOnDeleteClicked"]))
                : (_openBlock(), _createElementBlock("div", _hoisted_42, _hoisted_44))
            ])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])
    ])
  ], 64))
}